import { render, staticRenderFns } from "./CardRow.vue?vue&type=template&id=651de9a7&scoped=true&lang=html&"
import script from "./CardRow.vue?vue&type=script&lang=js&"
export * from "./CardRow.vue?vue&type=script&lang=js&"
import style0 from "./CardRow.vue?vue&type=style&index=0&id=651de9a7&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651de9a7",
  null
  
)

export default component.exports